var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoga(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.997C10.3807 15.997 11.5 14.8777 11.5 13.497C11.5 12.1163 10.3807 10.997 9 10.997C7.61929 10.997 6.5 12.1163 6.5 13.497C6.5 14.8777 7.61929 15.997 9 15.997Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.013 5.313C15.0617 5.04261 14.883 4.7836 14.613 4.733C13.7955 4.57749 12.9652 4.49849 12.133 4.497C9.12163 4.50227 6.197 5.50598 3.81701 7.351L2.57901 8.313C2.28575 8.54118 2.08762 8.87009 2.02301 9.236L1.85201 10.204C1.80805 10.4545 1.9591 10.698 2.20301 10.77L4.13201 11.342C4.2686 11.3827 4.41605 11.3631 4.53732 11.2882C4.65859 11.2134 4.74215 11.0903 4.76701 10.95L4.81001 10.706C4.85325 10.4621 4.98545 10.243 5.18101 10.091L5.65801 9.719C7.51185 8.28346 9.78933 7.50308 12.134 7.5C12.7845 7.50137 13.4335 7.56466 14.072 7.689C14.203 7.71443 14.3386 7.68648 14.4489 7.61136C14.5591 7.53624 14.6348 7.42018 14.659 7.289C14.758 6.73 14.916 5.854 15.013 5.313Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.115 9.994C21.4337 7.84265 19.1813 6.20741 16.615 5.275C16.4773 5.22666 16.3253 5.24091 16.199 5.314C16.0719 5.3873 15.9834 5.5127 15.957 5.657C15.852 6.238 15.69 7.129 15.595 7.648C15.5516 7.88481 15.6832 8.1189 15.908 8.205C17.4633 8.79837 18.8558 9.75213 19.971 10.988C20.25 11.299 20.496 11.507 20.496 11.956V18C20.496 18.8284 21.1676 19.5 21.996 19.5C22.8244 19.5 23.496 18.8284 23.496 18V11C23.4978 10.6291 23.362 10.2707 23.115 9.994Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.13901 11.784C2.00227 11.7433 1.85468 11.763 1.73338 11.8381C1.61208 11.9132 1.52862 12.0365 1.50401 12.177L0.523005 17.736C0.378859 18.552 0.923504 19.3304 1.73951 19.4745C2.55551 19.6186 3.33386 19.074 3.478 18.258L4.41901 12.924C4.46306 12.6738 4.31251 12.4304 4.06901 12.358L2.13901 11.784Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoga);
export default __webpack_public_path__ + "static/media/yoga.6a68f371.svg";
export { ForwardRef as ReactComponent };